import { computed, ref } from 'vue';

export class Config {
  static get getInstance () {
    if (!this.instance) {
      this.instance = new Config();
    }
    return this.instance;
  }

  get apiUrl () {
    return computed(() => this.config.value?.apiUrl || '');
  }
  constructor () {
    this.loaded = ref(false);
    if (import.meta.client) {
      let configStr = localStorage.getItem('config');
      if (configStr) {
        this.config = ref(JSON.parse(configStr));
      } else {
        this.config = ref({});
      }
    }else {
      this.config = ref({});
    }
  }

  async init () {
    await this.loadConfig();
    this.loaded.value = true;
  }

  async loadConfig () {
    try {
      let resp = await useConfigInfo();
      if (resp.code != 200) {
        return false;
      }
      this.syncConfig(resp.data);
      return true;
    } catch (_) {
      return false;
    }
  }

  syncConfig (config) {
    this.config.value = config;
    if (import.meta.client) {
      let configStr = JSON.stringify(config);
      localStorage.setItem('config', configStr);
    }
  }
}
